import { RowMiddle } from 'layout/Components/Row'
import TransText from 'UIKit/Text/TransText'
import ToogleMode from './ToogleMode'

const ViewModeInDesktop: React.FC<{ isUnread: boolean; onValueChanged: (value: boolean) => void }> = ({
  isUnread,
  onValueChanged,
}) => {
  return (
    <RowMiddle>
      <TransText fontSize="12px" fontWeight={600} mr="8px" color="text_primary">
        Show Unread
      </TransText>

      <ToogleMode value={isUnread} onValueChanged={onValueChanged} />
    </RowMiddle>
  )
}

export default ViewModeInDesktop
